"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiLinearProgress = function MuiLinearProgress() {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 4,
      borderRadius: 4
    },

    /* Styles applied to the layered bar1 and bar2 elements. */
    bar: {
      borderRadius: 4
    }
  };
};

var _default = MuiLinearProgress;
exports["default"] = _default;